import React from 'react'
import "./Footer.css"

const Footer = () => {
    return (
        <div className='footer'>Created by Gulshan Sharma with ❤</div>
    )
}

export default Footer